import { PostStatusEnum } from 'modules/community/enums/post-status-enum'

export const PostStatusLocoKey: Record<PostStatusEnum, string> = {
  [PostStatusEnum.Approved]: 'post.status.approved',
  [PostStatusEnum.Declined]: 'post.status.declined',
  [PostStatusEnum.Pending]: 'post.status.pending',
  [PostStatusEnum.Scheduled]: 'post.status.scheduled',
}

export const ACTIVITY_CLEANUP_PERIOD_DURATION = 7
